import { ELanguage } from '@microfrontends/app-shell-v2'
import React from 'react'
import { EDevice } from '../containers/SalaryGrossNet/constant'
import { IUser } from '../services/auth/@type'

export type TAppContext = {
	serviceWorker: ServiceWorker | null
	user: IUser | null
	userIP: string
	languageCode?: ELanguage
	breakpoint?: EDevice
	utm?: string
	data?: any
	t: (key: string) => string
	[props: string]: any
}

const AppContext = React.createContext<TAppContext>({
	serviceWorker: null,
	user: null,
	userIP: '',
	breakpoint: EDevice.DESKTOP,
	utm: '',
	data: null,
	t: () => ''
})

export default AppContext
